import { z } from 'zod';
import { TenantIdSchema, MoneySchema, IsoDateSchema } from './_primitives.js';

export const INVOICE_STATE = Object.freeze({
  DRAFT:    'draft',
  ISSUED:   'issued',
  SENT:     'sent',
  PAID:     'paid',
  PARTIAL:  'partial',
  OVERDUE:  'overdue',
  DISPUTED: 'disputed',
  VOID:     'void',
});

export const InvoiceStateEnum = z.enum(Object.values(INVOICE_STATE));

const InvoiceLineItemSchema = z.object({
  id:          z.string().optional(),
  description: z.string().min(1),
  quantity:    z.union([z.string(), z.number()]),
  uom:         z.string(),
  unitPrice:   z.number().int(),
  amount:      z.number().int(),
}).passthrough();

export const InvoiceSchema = z.object({
  tenantId:       TenantIdSchema,
  id:             z.string().optional(),
  invoiceNumber:  z.string().optional(),
  state:          InvoiceStateEnum.optional(),
  billingEntityId: z.string().optional(),
  counterpartyId:  z.string().optional(),
  currency:        z.string().length(3),
  subtotal:        z.number().int().optional(),
  total:           z.number().int().optional(),
  amountDue:       z.number().int().optional(),
  lineItems:       z.array(InvoiceLineItemSchema).optional(),
  issueDate:       z.union([IsoDateSchema, z.object({})]).optional(),
  dueDate:         z.union([IsoDateSchema, z.object({})]).optional(),
  paidAt:          IsoDateSchema.optional(),
  loadIds:         z.array(z.string()).optional(),
  softDeleted:     z.boolean().optional(),
  createdAt:       z.union([IsoDateSchema, z.object({})]).optional(),
  updatedAt:       z.union([IsoDateSchema, z.object({})]).optional(),
  version:         z.number().int().optional(),
}).passthrough();

/** @typedef {import('zod').infer<typeof InvoiceSchema>} Invoice */
